import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledShimmer } from './Shimmer.styles.js';

const Shimmer = forwardRef((props, ref) => {
    return jsx(StyledShimmer, Object.assign({ ref: ref }, props));
});

export { Shimmer as default };
//# sourceMappingURL=Shimmer.js.map
